import React from "react";
import { ShippingManagementMain } from "../pages/Shipping";
import { User } from "../pages/Shipping/types";

interface ShippingManagementProps {
  currentUser?: User;
}

const ShippingManagement: React.FC<ShippingManagementProps> = ({
  currentUser,
}) => {
  return <ShippingManagementMain currentUser={currentUser} />;
};

export default ShippingManagement;
